import React from "react";
import { about } from "../data";
import useReveal from "../hooks/useReveal";

export default function About() {
  const [ref, visible] = useReveal();
  return (
    <section className="about" id="despre">
      <div ref={ref} className={`about__inner reveal ${visible ? "is-visible" : ""}`}>
        <div className="about__text">
          <span className="section__kicker">Despre LEASEIN</span>
          <h2>{about.title}</h2>
          {about.paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
        <div className="about__stats">
          {about.stats.map((s, i) => (
            <div key={i} style={{ "--d": `${i * 0.1}s` }}>
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
